<div class="loginModal">
    <div class="modal-header">
        <h5 class="modal-title" id="loginModalLabel"><i class="fa fa-user mx-2"></i> Login/Sign Up</h5>
        <button (click)="close()"><span aria-hidden="true" class="cross">X</span></button>
    </div>

    <div class="modal-body">

        <div *ngIf="isSignInPage">
            <div *ngIf="isSignInByPhone">
                <label >{{msgDisplayBody}}<span>*</span></label>
                <input [(ngModel)]="signInObj.phone" type="text" class="inField" id="phone"
                placeholder="Enter your {{msgDisplayBody}}" minlength="10" maxlength="10"
                (input)="checkPhoneRegx($event)" (keydown.enter)="continue()">
                <div *ngIf="error!='' && isSubmit" class="alert alert-danger"> {{error}} </div>
            </div>
            
            <div *ngIf="!isSignInByPhone">
                <label >{{msgDisplayBody}}<span>*</span></label>
                <input [(ngModel)]="signInObj.email" type="text" class="inField" id="email"
                    placeholder="Enter your {{msgDisplayBody}}" (input)="checkEmailRegx($event)"
                    (keydown.enter)="continue()">
                <div *ngIf="error!='' && isSubmit" class="alert alert-danger"> {{error}} </div>
            </div>
        </div>

        <div class="varifyMob" *ngIf="!isSignInPage">
            <h4>Verify {{msgDisplayBody}}</h4>

            <p>Please check the OTP sent to your {{msgDisplayBody}}</p>

            <div class="vMob">
                <h5>{{isSignInByPhone ? phone : email}}</h5>
                <button type="button" (click)="change()">Change</button>
            </div>

            <span style="font-size: 16px;">Enter OTP</span>
            <form [formGroup]="form">
                <div class="otpBoxes">
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="row no-gutters">
                                <div class="form-group col-2" *ngFor="let input of formInput;  index as i">
                                    <input autofocus #formRow type="text" formControlName="{{input}}" maxlength="1"
                                        (keyup)="keyUpEvent($event, i)" (keydown.enter)="continue()">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="error!=''" class="alert alert-danger"> {{error}} </div>
                    <button type="button" (click)="resendOtp()" [disabled]="counter!=0">Resend OTP</button>
                    <span class="otpcountDown" style="font-size: 16px;" *ngIf="counter">{{transform(counter)}}</span>
                </div>
            </form>
        </div>

    </div>

    <div class="modal-footer">
        <ng-container *ngIf="isSignInPage">
            <!-- <button type="button" id="loginuEmail" (click)="changeSignUpMethod()">
                    Login using {{msgDisplayFooter}}
                </button> -->
            <button class="btn theme-btn btn-secondary" type="submit" [disabled]="isApiHit" (click)="continue()">
                Continue
                <span *ngIf="isApiHit" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-container>

        <ng-container *ngIf="!isSignInPage">
            <input type="submit" class="theme-btn" value="Continue" (click)="continue()">
        </ng-container>
    </div>
</div>